export default {
  title: 'Zamów wcześniej',
  categories: {
    title: 'Najpopularniejsze',
  },
  header: {
    pickup: 'Odbiór za 5 minut',
  },
};
